
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import get from 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import './collapse-transition-mixin.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import './pendo-divider.js';
import 'element-ui/lib/checkbox';
import './pendo-checkbox.js';
import 'lodash/uniqueId';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/isPlainObject';
import 'lodash/debounce';
import './pendo-empty-state.js';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import './pendo-multiselect.js';
import './pendo-icon-button.js';
import './pendo-responsive.js';
import 'lodash/cloneDeep';
import 'lodash/keyBy';
import 'scrollparent';
import 'vue-observe-visibility';
import PendoTable from './pendo-table.js';
import './pendo-checkbox-cell.js';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import './pendo-column-reorder.js';
import './pendo-column-chooser.js';
import 'lodash/groupBy';
import PendoTabPanel from './pendo-tab-panel.js';
import PendoTabs from './pendo-tabs.js';
import PendoCsvModal from './pendo-csv-modal.js';
import PendoStatusOverlay from './pendo-status-overlay.js';

var script = {
  name: 'PendoGuideMetricsDrawerContent',
  components: {
    PendoButton,
    PendoTable,
    PendoTabs,
    PendoTabPanel,
    PendoCsvModal,
    PendoStatusOverlay
  },
  props: {
    csvDownloadAggId: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({
        accounts: [],
        visitors: []
      })
    },
    loading: {
      type: Boolean,
      default: false
    },
    csvModalStatus: {
      type: String,
      default: 'loading'
    },
    csvUrl: {
      type: String,
      default: ''
    },
    visitorUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    },
    showCreateSegment: {
      type: Boolean,
      default: false
    },
    showAccountsTab: {
      type: Boolean,
      default: true
    },
    showClicksColumn: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'app'
    },
    aggStatus: {
      type: Object,
      default: () => ({
        accounts: null,
        visitors: null
      })
    }
  },

  data() {
    return {
      activeTab: 'visitor',
      showCsvModal: false
    };
  },

  computed: {
    tabs() {
      return [{
        label: 'Visitors',
        prop: 'visitor',
        data: get(this.data, 'visitors') || [],
        aggStatus: get(this.aggStatus, 'visitors')
      }, this.showAccountsTab && {
        label: 'Accounts',
        prop: 'account',
        data: get(this.data, 'accounts') || [],
        aggStatus: get(this.aggStatus, 'accounts')
      }].filter(Boolean);
    },

    tableColumns() {
      return [this.activeTab === 'visitor' && {
        href: row => {
          if (!this.visitorUrl) {
            return false;
          }

          if (row.href) {
            return row.href;
          }

          return `${this.visitorUrl}/${encodeURIComponent(row.id)}`;
        },
        label: 'Visitor ID',
        prop: 'id',
        sortable: true,
        target: '_blank',
        type: 'link'
      }, this.activeTab === 'account' && {
        href: row => {
          if (row.id === '(none)' || !this.accountUrl) {
            return false;
          }

          if (row.href) {
            return row.href;
          }

          return `${this.accountUrl}/${encodeURIComponent(row.id)}`;
        },
        label: 'Account ID',
        prop: 'id',
        sortable: true,
        target: '_blank',
        type: 'link'
      }, this.showClicksColumn && {
        label: 'Clicks',
        prop: 'clicks',
        sortable: true,
        width: 120
      }].filter(Boolean);
    }

  },
  methods: {
    downloadCsv() {
      this.showCsvModal = true;
      this.$emit('download-csv', {
        activeTab: this.activeTab,
        csvDownloadAggId: this.csvDownloadAggId
      });
    },

    createSegment() {
      this.$emit('create-segment', this.activeTab);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-guide-metrics-drawer-content"
  }, [_c('div', {
    staticClass: "pendo-guide-metrics-drawer-content-body"
  }, [_c('pendo-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "theme": _vm.theme
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function (ref) {
        var tab = ref.tab;
        return [_c('div', {
          staticClass: "pendo-guide-metrics-drawer-content-body__tab-label"
        }, [_vm._v("\n                    " + _vm._s(tab.label) + " (" + _vm._s(tab.data.length) + ")\n                ")])];
      }
    }]),
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_vm._v(" "), _vm._l(_vm.tabs, function (tab) {
    return _c('pendo-tab-panel', {
      key: tab.prop,
      attrs: {
        "prop": tab.prop,
        "label": tab.label,
        "lazy": "",
        "active": tab.prop === _vm.activeTab
      }
    }, [_c('pendo-table', {
      attrs: {
        "loading": _vm.loading,
        "borderless": "",
        "condensed": "",
        "auto-height": "",
        "csv-download": "",
        "auto-height-offset": 68,
        "data": tab.data,
        "columns": _vm.tableColumns
      },
      scopedSlots: _vm._u([{
        key: "status",
        fn: function () {
          return [_c('pendo-status-overlay', {
            attrs: {
              "state": tab.aggStatus
            }
          })];
        },
        proxy: true
      }], null, true)
    })], 1);
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "pendo-guide-metrics-drawer-content-footer"
  }, [_c('pendo-button', {
    class: {
      'pendo-guide-metrics-drawer-content-footer__button': _vm.showCreateSegment
    },
    attrs: {
      "block": !_vm.showCreateSegment,
      "theme": _vm.theme,
      "prefix-icon": "download",
      "type": "secondary",
      "label": "Download CSV"
    },
    on: {
      "click": _vm.downloadCsv
    }
  }), _vm._v(" "), _vm.showCreateSegment ? _c('pendo-button', {
    class: {
      'pendo-guide-metrics-drawer-content-footer__button': _vm.showCreateSegment
    },
    attrs: {
      "theme": _vm.theme,
      "prefix-icon": "plus",
      "type": "primary",
      "label": "Create Segment"
    },
    on: {
      "click": _vm.createSegment
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('pendo-csv-modal', {
    attrs: {
      "visible": _vm.showCsvModal,
      "status": _vm.csvModalStatus,
      "url": _vm.csvUrl
    },
    on: {
      "close": function ($event) {
        _vm.showCsvModal = false;
      }
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-guide-metrics-drawer-content.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoGuideMetricsDrawerContent = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoGuideMetricsDrawerContent;
